import { render, staticRenderFns } from "./PartnerContact.vue?vue&type=template&id=c798089e&scoped=true"
import script from "./PartnerContact.vue?vue&type=script&lang=js"
export * from "./PartnerContact.vue?vue&type=script&lang=js"
import style0 from "./PartnerContact.vue?vue&type=style&index=0&id=c798089e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c798089e",
  null
  
)

export default component.exports